<template>
  <div>
    <h1>Getting Started</h1>

    <div v-if="getStartedContent !== ''" v-html="getStartedContent" />
    <div class="actions">
      <router-link :to="{ name: 'NewMember' }">Cancel</router-link>
      <button @click="startRegistration" class="btn btn--positive">
        Start Registration
      </button>
    </div>
  </div>
</template>

<script>
import { registrationConfig } from "@/helpers/config";
import { useMemberDetails } from "@/helpers/member-details";

export default {
  name: "GettingStarted",
  setup(_, ctx) {
    const { membershipType, membershipStatusType } = useMemberDetails();

    const getStartedContent =
      registrationConfig.fees.find(
        (f) => f.memStatusCode === membershipStatusType.value,
      )?.getStartedContent ?? "";

    const startRegistration = () =>
      ctx.root.$router.push({ name: "Contact Details" });

    return {
      membershipType,
      membershipStatusType,
      getStartedContent,
      startRegistration,
    };
  },
};
</script>

<style lang="scss" scoped>
.icons {
  align-items: center;
  display: flex;

  svg {
    margin-right: 16px;
    max-height: 65px;
  }
}

.actions {
  align-items: center;
  display: flex;
  justify-content: flex-end;
  padding: 16px 0;

  .btn {
    margin-left: 16px;
    min-width: 180px;
    background-color: var(--green);
    border-color: var(--green);

    &:hover {
      background-color: var(--light-green);
      border-color: var(--light-green);
    }
  }
}
</style>
